var _path, _path2, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuisnessM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2765 34C26.2658 34 33.5531 26.6127 33.5531 17.5C33.5531 8.3873 26.2658 1 17.2765 1C8.28726 1 1 8.3873 1 17.5C1 26.6127 8.28726 34 17.2765 34Z",
    fill: "#FFC3A6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2313_34395",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 33,
    height: 33
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2765 34C26.2658 34 33.5531 26.6127 33.5531 17.5C33.5531 8.3873 26.2658 1 17.2765 1C8.28726 1 1 8.3873 1 17.5C1 26.6127 8.28726 34 17.2765 34Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2313_34395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.27622 27.2378C6.56941 27.2378 6 26.664 6 25.9572V13.0828C6 12.4235 6.49323 11.8779 7.13354 11.8017C7.1855 11.7969 7.23306 11.7969 7.27578 11.7969H26.7233C26.766 11.7969 26.8136 11.7969 26.8656 11.8017C27.5059 11.8775 27.9995 12.4231 27.9995 13.0828V25.9572C27.9995 26.664 27.4301 27.2378 26.7233 27.2378H7.27622Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2595 19.9188C11.1595 19.9188 10.1065 19.4766 9.33719 18.6901C7.82405 17.1431 6 15.26 6 15.26V13.0828C6 12.4235 6.49323 11.8779 7.13354 11.8017C7.1855 11.7969 7.23306 11.7969 7.27578 11.7969H26.7233C26.766 11.7969 26.8136 11.7969 26.8656 11.8017C27.5059 11.8775 27.9995 12.4231 27.9995 13.0828V15.26C27.9995 15.26 26.1755 17.1431 24.6628 18.6901C23.8934 19.4766 22.8405 19.9188 21.7404 19.9188H12.2595Z",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5404 22.1412C16.2176 22.1412 15.9561 21.8796 15.9561 21.5564V17.9941H18.0452V21.5564C18.0452 21.8792 17.7836 22.1412 17.4604 22.1412H16.5404Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2007 20.0371H15.7998V20.57H18.2007V20.0371Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4876 19.5192C15.2639 19.5192 15.082 19.3377 15.082 19.1136V18.3993C15.082 18.1756 15.2635 17.9941 15.4876 17.9941H18.5121C18.7358 17.9941 18.9173 18.1756 18.9173 18.3993V19.1136C18.9173 19.3373 18.7358 19.5192 18.5121 19.5192H15.4876Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5275 21.8923C16.3452 21.8923 16.1973 21.7444 16.1973 21.562V20.5703H17.8029V21.562C17.8029 21.7444 17.6549 21.8923 17.4726 21.8923H16.5275Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9792 18.7826C15.9792 18.9248 15.8638 19.0398 15.722 19.0398C15.5802 19.0398 15.4648 18.9248 15.4648 18.7826C15.4648 18.6403 15.5802 18.5254 15.722 18.5254C15.8638 18.5254 15.9792 18.6408 15.9792 18.7826Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0225 18.7826C18.0225 18.9248 18.1374 19.0398 18.2796 19.0398C18.4219 19.0398 18.5368 18.9248 18.5368 18.7826C18.5368 18.6403 18.4219 18.5254 18.2796 18.5254C18.1374 18.5254 18.0225 18.6408 18.0225 18.7826Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5096 20.9332C16.4514 20.9332 16.4043 20.886 16.4043 20.8279C16.4043 20.7698 16.4514 20.7227 16.5096 20.7227H17.4916C17.5497 20.7227 17.5968 20.7698 17.5968 20.8279C17.5968 20.886 17.5497 20.9332 17.4916 20.9332H16.5096Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5096 21.3375C16.4514 21.3375 16.4043 21.2903 16.4043 21.2322C16.4043 21.1741 16.4514 21.127 16.5096 21.127H17.4916C17.5497 21.127 17.5968 21.1741 17.5968 21.2322C17.5968 21.2903 17.5497 21.3375 17.4916 21.3375H16.5096Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5086 21.7378C16.4504 21.7378 16.4033 21.6907 16.4033 21.6326C16.4033 21.5745 16.4504 21.5273 16.5086 21.5273H17.4906C17.5488 21.5273 17.5959 21.5745 17.5959 21.6326C17.5959 21.6907 17.5488 21.7378 17.4906 21.7378H16.5086Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0002 10.7953C16.2124 10.7953 15.4241 11.0115 14.7305 11.4444C14.5292 11.5691 14.2641 11.5532 14.1259 11.3819C13.988 11.2115 14.0638 10.9226 14.3099 10.7693C15.1321 10.2563 16.0662 10 17.0002 10C17.9342 10 18.8683 10.2563 19.6905 10.7693C19.9366 10.9226 20.0124 11.2115 19.8745 11.3819C19.7367 11.5532 19.4716 11.5691 19.2699 11.4444C18.5763 11.012 17.7885 10.7953 17.0002 10.7953Z",
    fill: "#3C3C3B"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2765 34C26.2658 34 33.5531 26.6127 33.5531 17.5C33.5531 8.3873 26.2658 1 17.2765 1C8.28726 1 1 8.3873 1 17.5C1 26.6127 8.28726 34 17.2765 34Z",
    stroke: "#080C3E",
    strokeWidth: 0.5705,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuisnessM);
export default __webpack_public_path__ + "static/media/BuisnessM.c0dc1cda021566c525fffd6e867b5bd3.svg";
export { ForwardRef as ReactComponent };